import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SAJButtonModule } from '@snagajob/button';
import { SAJMenuModule } from '@snagajob/menu';
import { SAJLabelModule } from '@snagajob/label';
import { HubPageHeaderComponent } from './page-header/page-header.component';
import { HubPageComponent } from './page.component';
import {
  SAJIconCloseComponent,
  SAJIconHamburgerAltComponent,
  SAJIconHealthComponent,
  SAJIconOverflowComponent,
  SAJIconShareComponent,
} from '@snagajob/icons';
import { HubButtonModule } from '@libs/components/button';
import { HubTemplateDirective } from '@libs/components/directives';
import { HubPageDrawerComponent } from './page-drawer/page-drawer.component';
import { SAJTooltipModule } from '@snagajob/tooltip';

@NgModule({
  imports: [
    CommonModule,
    HubButtonModule,
    SAJButtonModule,
    SAJMenuModule,
    SAJLabelModule,
    SAJIconHamburgerAltComponent,
    SAJIconOverflowComponent,
    SAJIconHealthComponent,
    SAJIconShareComponent,
    HubTemplateDirective,
    SAJIconCloseComponent,
    SAJTooltipModule,
  ],
  declarations: [
    HubPageComponent,
    HubPageHeaderComponent,
    HubPageDrawerComponent,
  ],
  exports: [
    HubPageComponent,
    HubPageHeaderComponent,
    HubPageDrawerComponent,
    SAJButtonModule,
    SAJMenuModule,
    SAJIconHamburgerAltComponent,
    SAJIconOverflowComponent,
    HubTemplateDirective,
  ],
})
export class HubPageModule {}
